export default "__VITE_ASSET__DQo7ERpT__"